export const FETCH_USER_MOST_COMMON_HEALTH_TOPICS =
  "FETCH_USER_MOST_COMMON_HEALTH_TOPICS";
export const FETCH_ADMIN_MOST_COMMON_HEALTH_TOPICS =
  "FETCH_ADMIN_MOST_COMMON_HEALTH_TOPICS";
export const FETCH_ADMIN_COMPLETE_DATA = "FETCH_ADMIN_COMPLETE_DATA";
export const FETCH_ADMIN_DOCUMENT_DATA = "FETCH_ADMIN_DOCUMENT_DATA";
